import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

export const InitiativeHierarchyContext = createContext({ ancestors: [] })

const InitiativeHierarchyProvider = ({ children, initiative, refetchInitiative }) => {
   const {
      ancestors: currentAncestors,
      initiative: currentInitiative
   } = useContext(InitiativeHierarchyContext)

   const newContextValue = {
      initiative,
      refetchInitiative,
      ancestors: currentInitiative
         ? [...currentAncestors, currentInitiative]
         : currentAncestors
   }

   return (
      <InitiativeHierarchyContext.Provider value={newContextValue}>
         {children}
      </InitiativeHierarchyContext.Provider>
   )
}

InitiativeHierarchyProvider.propTypes = {
   children: PropTypes.node.isRequired,
   // TODO: Replace with InitiativePropType
   initiative: PropTypes.object,
   refetchInitiative: PropTypes.func
}

InitiativeHierarchyProvider.defaultProps = {
   initiative: undefined,
   refetchInitiative: undefined
}

export { InitiativeHierarchyProvider }
